import { tuiInputDateOptionsProvider } from '@taiga-ui/kit';
import { Provider } from '@angular/core';
import { TuiDay, TuiValueTransformer } from '@taiga-ui/cdk';
// Form DATE answers are stored as `yyyy-MM-dd` strings (see @pixacare/forms answer parsing).
// TuiInputDate works with TuiDay, so we transform between the string control value and TuiDay.
// Without this, the global Date-based transformer breaks writeValue and the control never updates.
export const formDateValueTransformer: TuiValueTransformer<TuiDay | null, string | null> = {
  fromControlValue: (value: string | null): TuiDay | null => (value ? TuiDay.jsonParse(value) : null),
  toControlValue: (value: TuiDay | null): string | null => (value ? value.toJSON() : null),
};

export const provideFormDateValueTransformer = (): Provider =>
  tuiInputDateOptionsProvider({ valueTransformer: formDateValueTransformer });
